<template>
  <div id="signUpForm" class="signUpContainer">
    <div class="box">
      <figure class="image">
        <img
          class="image registerLogo"
          :src="require('@/assets/images/JPEG/MyGymChecker-Logo-JPEG-BlackBlue-transparent.jpg')"
        />
      </figure>
      <transition name="fade" mode="out-in">
        <div
          v-if="!success"
          class="signUp"
          key="1"
        >
          <SignUpForm @success="fade" />
        </div>
        <div v-else key="2" class="successfulApplication">
          <h2
            class="title submitted is-2 has-text-centered"
          >
            Account Created
          </h2>
          <h2
            class="subtitle submitted has-text-centered"
          >
            We will now redirect you to your personalised dashboard.
          </h2>
          <h2
            v-if="not_redirected"
            class="subtitle submitted has-text-centered"
          >
            If you are not automatically redirected, <a :href="`${dashboardUrl}/auth/login?token=${token}`">please click here.</a>
          </h2>
          
          <sweetalert-icon icon="success" color="#00c5fd"></sweetalert-icon>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import SweetalertIcon from "vue-sweetalert-icons";
import SignUpForm from "../atoms/SignUpForm";
export default {
  components: {
    SweetalertIcon,
    SignUpForm,
  },
  data() {
    return {
      dashboardUrl: process.env.VUE_APP_BASE_DASHBOARD_URL,
      not_redirected: false,
      stored_credentials: {},
      success: false,
      token: undefined,
    };
  },
  methods: {
    fade(credentials) {
      this.stored_credentials = credentials;
      this.success = true;
      setTimeout( () => { this.login(credentials); }, 2400);
      setTimeout( () => { this.not_redirected = true; }, 3400);
    },
    async login(credentials) {
      try {
        const response = await this.$http.post('/api/auth/login', { email: credentials.email, password: credentials.password });
        this.token = response.data.token;
        window.location.href = `${this.dashboardUrl}/auth/login?token=${this.token}`;
      } catch (error) {
        console.error(error);
      }
    }
  },
};
</script>

<style>

.signUpContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 6rem auto;
}

.successfulApplication {
  height: fixed;
}

.signUpSubtitle {
  width: 50%;
  font-size: calc(1rem + 0.5vw);
  /* -webkit-text-stroke: 1px black; */
  color: white;
  text-shadow: 0 0 5px black;
}

.signUp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.register-button {
  width: 50%;
}

.registerLogo{
  max-width: 600px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
